/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SegmentOutParticipant } from './segmentOutParticipant';

export interface SegmentOut {
  id: string;
  idx: number;
  start_ms: number;
  end_ms: number;
  speaker_label: string | null;
  participant: SegmentOutParticipant;
  text: string | null;
  marker: string | null;
  room: string | null;
  pre_start: boolean;
  low_confidence_language: boolean;
}
